export default "__VITE_ASSET__Bg1zYpMM__"